import * as _ from 'lodash';

const ClaveEntidadOptions = ( Ambito = '', ruleData = {}) => {

  let options = [
    {
      label: 'Selecciona',
      value: '',
    },
    {
      label: 'Aguascalientes',
      value:'AGU'
    },
    {
      label: 'Baja California',
      value:'BCN'
    },
    {
      label: 'Baja California Sur',
      value:'BCS'
    },
    {
      label: 'Campeche',
      value:'CAM'
    },
    {
      label: 'Chiapas',
      value:'CHP'
    },
    {
      label: 'Chihuahua',
      value:'CHH'
    },
    {
      label: 'Coahuila',
      value:'COA'
    },
    {
      label: 'Colima',
      value:'COL'
    },
    {
      label: 'Ciudad de México',
      value:'DIF'
    },
    {
      label: 'Durango',
      value:'DUR'
    },
    {
      label: 'Guanajuato',
      value:'GUA'
    },
    {
      label: 'Guerrero',
      value:'GRO'
    },
    {
      label: 'Hidalgo',
      value:'HID'
    },
    {
      label: 'Jalisco',
      value:'JAL'
    },
    {
      label: 'México',
      value:'MEX'
    },
    {
      label: 'Michoacán',
      value:'MIC'
    },
    {
      label: 'Morelos',
      value:'MOR'
    },
    {
      label: 'Nayarit',
      value:'NAY'
    },
    {
      label: 'Nuevo León',
      value:'NLE'
    },
    {
      label: 'Oaxaca',
      value:'OAX'
    },
    {
      label: 'Puebla',
      value:'PUE'
    },
    {
      label: 'Querétaro',
      value:'QUE'
    },
    {
      label: 'Quintana Roo',
      value:'ROO'
    },
    {
      label: 'San Luis Potosí',
      value:'SLP'
    },
    {
      label: 'Sinaloa',
      value:'SIN'
    },
    {
      label: 'Sonora',
      value:'SON'
    },
    {
      label: 'Tabasco',
      value:'TAB'
    },
    {
      label: 'Tamaulipas',
      value:'TAM'
    },
    {
      label: 'Tlaxcala',
      value:'TLA'
    },
    {
      label: 'Veracruz',
      value:'VER'
    },
    {
      label: 'Yucatán',
      value:'YUC'
    },
    {
      label: 'Zacatecas',
      value:'ZAC'
    }
  ];


  let optionsFederal = [
    {
      label: 'Selecciona',
      value: '',
    },
    {
      label: 'Nacional',
      value:'NAC'
    },
    {
    label: 'Circunscripción 1',
    value:'CR1'
    },
    {
    label: 'Circunscripción 2',
    value:'CR2'
    },
    {
    label: 'Circunscripción 3',
    value:'CR3'
    },
    {
    label: 'Circunscripción 4',
    value:'CR4'
    },
    {
    label: 'Circunscripción 5',
    value:'CR5'
    },
  ];

  const { TipoComite = '' } = ruleData;

  if (_.isEqual(TipoComite, 'Ejecutivo Estatal') || _.isEqual(TipoComite, 'Directivo Estatal')) {
    return [].concat(options, optionsFederal);
  }

  if (_.isEqual(Ambito, 'Local')) {
    return options;
  }

  if (_.isEqual(Ambito, 'Federal')) {
    return [].concat(options, optionsFederal);
  }

  if (_.isEqual(Ambito, '') || _.isEqual(TipoComite, '')) {
    return [{
      label: 'Selecciona',
      value: '',
    }];
  }
};

export default ClaveEntidadOptions;
